import { MeasurementDate } from 'api/models/MeasurementDate';
import { Fund } from 'common/types/fund';
import { ReducerAction, ReducerState } from 'common/types/reducers';

/**
 * @function
 * @name setFundInfo
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const setFundInfo = (state: ReducerState, action: ReducerAction<{ fundInfo: Fund }>) => ({
  ...state,
  ...action,
});

export const setFundList = (state: ReducerState, action: ReducerAction<{ fundList: Fund[] | null }>) => ({
  ...state,
  ...action,
});

export const setCurrentMpByFund = (
  state: ReducerState,
  action: ReducerAction<{ currentMeasurementDateByFund: MeasurementDate }>
) => ({ ...state, ...action });

export const getFundSummaryInfo = (state: ReducerState, action: ReducerAction<any>) => ({
  ...state,
  ...action,
});
